var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"register__row"},[(!_vm.hideLeft)?_c('RegisterSteps',{attrs:{"description":_vm.description,"title":'Восстановление пароля'}}):_vm._e(),_c('RestoreForm',{on:{"changeStep":_vm.changeStep}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }